import { type EffectCallback, useEffect, useRef } from 'react';

/**
 * Will only run the callback (inside a regular `useEffect`) once. If a
 * `when` value is provided, the callback will only be run once that value
 * becomes truthy.
 */
export const useEffectOnce = (callback: EffectCallback, options: { when?: boolean } = {}) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current || options.when === false) return;

    hasRun.current = true;
    const result = callback();
    if (typeof result === 'function') {
      return result;
    }
    return undefined;
  }, [callback, options.when]);
};
